import logo from "LandingPage/Assets/logo.png";
import styles from "./Footer.module.scss";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const cazoodleUrl =
    process.env.REACT_APP_CAZOODLE_URL || "https://www.cazoodle.com";

  return (
    <footer className={styles["footer"]} id="homepage-footer">
      <div className={styles["footer__container"]}>
        {/* ─── Brand Column ─── */}
        <div className={styles["footer__brand"]}>
          <img
            src={logo}
            alt="Cazoodle Logo"
            className={styles["footer__logo"]}
          />
          <p className={styles["footer__tagline"]}>
            Building mission-critical intelligence tools for the world&apos;s
            leading research institutions.
          </p>
        </div>

        {/* ─── Products Column ─── */}
        <nav className={styles["footer__nav"]} aria-label="Products navigation">
          <h4 className={styles["footer__nav-title"]}>Products</h4>
          <ul className={styles["footer__nav-list"]}>
            <li>
              <a
                href="/explore"
                target="_blank"
                rel="noopener noreferrer"
                className={styles["footer__link"]}
              >
                Explore
              </a>
            </li>
            <li>
              <a
                href="https://public-profile.academic.online"
                target="_blank"
                rel="noopener noreferrer"
                className={styles["footer__link"]}
              >
                Public Profile
              </a>
            </li>
          </ul>
        </nav>

        {/* ─── Company Column ─── */}
        <nav className={styles["footer__nav"]} aria-label="Company navigation">
          <h4 className={styles["footer__nav-title"]}>Company</h4>
          <ul className={styles["footer__nav-list"]}>
            <li>
              <a
                href={`${cazoodleUrl}/about`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles["footer__link"]}
              >
                About Us
              </a>
            </li>
            <li>
              <a
                href={`${cazoodleUrl}/careers`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles["footer__link"]}
              >
                Careers
              </a>
            </li>
          </ul>
        </nav>

        {/* ─── Legal Column ─── */}
        <nav className={styles["footer__nav"]} aria-label="Legal navigation">
          <h4 className={styles["footer__nav-title"]}>Legal</h4>
          <ul className={styles["footer__nav-list"]}>
            <li>
              <a
                href={`${cazoodleUrl}/privacy-policy`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles["footer__link"]}
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href={`${cazoodleUrl}/terms-of-service`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles["footer__link"]}
              >
                Terms of Service
              </a>
            </li>
          </ul>
        </nav>
      </div>

      {/* ─── Bottom Bar ─── */}
      <div className={styles["footer__bottom"]}>
        <p className={styles["footer__copyright"]}>
          &copy; {currentYear} Cazoodle, Inc. All rights reserved.
        </p>
        <p className={styles["footer__region"]}>USA</p>
      </div>
    </footer>
  );
};

export default Footer;
